import styled from "styled-components";

export const ContainerMaintainers = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 30px;
`;
export const ContainerTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
`;
